module.exports = __webpack_public_path__ + "img/gpsl.0023395b.png";